module.exports = __webpack_public_path__ + "img/icon-payment-visa.69d7eaf3.png";